import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../Css/Newsletter.css";

function Newsletters() {
  const [files, setFiles] = useState([]);
  const [baseUrl, setBaseUrl] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const apiUrl = "https://api.gkaglobal.org/restgka/admin/news.php";

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setFiles(data.files);
          setBaseUrl(data.baseurl);
        } else {
          setError("Error: " + data.message);
        }
      })
      .catch((err) =>
        setError("Failed to retrieve files. Error: " + err.message)
      );
  }, []);

  return (
    <div className="newsletter-container">
      <h1>GKA News Latter</h1>
      <hr className="hr1" />
      <div id="file-list">
        {error ? (
          <p className="center-text">{error}</p>
        ) : (
          files.map((fileUrl, index) => {
            const fileName = fileUrl.split(".").slice(0, -1).join(".");
            return (
              <center key={index}>
                <p className="manav">
                  <Link
                    to={`${baseUrl}/${fileUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {fileName}
                  </Link>
                </p>
              </center>
            );
          })
        )}
      </div>
    </div>
  );
}

export default Newsletters;
